/// <amd-module name="Reporting/Samples/VisualsCommonSamples" />
import * as React from "react";

import { VssComponent } from "VSS/Platform/Layout";

import { AxFaultInMessage } from "Reporting/Visuals/VisualMessages/AxFaultInMessage";
import { ErrorMessage } from "Reporting/Visuals/VisualMessages/ErrorMessage";
import { NoDataMessage } from "Reporting/Visuals/VisualMessages/NoDataMessage";
import { UnconfiguredMessage } from "Reporting/Visuals/VisualMessages/UnconfiguredMessage";
import { VisualTitle } from "Reporting/Visuals/VisualTitle";

/** Provides demonstration of common visual components for use in Report Visuals and Dashboard Widgets. */
export class VisualsCommonSamples extends VssComponent {
    public render(): JSX.Element {
        const visualName = "Sample Visual";
        return (
            <div>
                To help Visual and Widget Authors in creating consistent reporting experiences, a suite of components are available from
                "reporting-visuals-common" Project
                <div>
                    <span>VisualTitle</span>
                    <span>
                        VisualTitle Component provides a consistent header experience, which is semantically recognizable by screen readers as H2
                        element. Note: Layout and positioning of a Visual title remains the responsibility of consumer.{" "}
                    </span>
                    <div className="demo-visual-cell two-by-one-layout">
                        <VisualTitle text={visualName} />
                    </div>
                </div>
                <br />
                <div>
                    <span>NoDataMessage</span>
                    <span>This provides a set of friendly "empty chart" experiences, where the user would otherwise see a blank chart page.</span>
                    <div className="demo-visual-cell two-by-two-layout">
                        <NoDataMessage visualTitle={visualName} size={{ width: 330, height: 330 }} />
                    </div>
                </div>
                <div>
                    <span>AxFaultInMessage</span>
                    <span>This covers for analytics fault in experiences, where sync jobs are bringing data to Ax for first time.</span>
                    <div className="demo-visual-cell two-by-two-layout">
                        <AxFaultInMessage visualTitle={visualName} size={{ width: 330, height: 330 }} />
                    </div>
                </div>
                <div>
                    <span>UnconfiguredMessage</span>
                    <span>This is for newly created widgets, as well as widgets with invalid/corrupted configuration state.</span>
                    <div className="demo-visual-cell two-by-two-layout">
                        <UnconfiguredMessage visualTitle={visualName} size={{ width: 330, height: 330 }} />
                    </div>
                </div>
                <div>
                    <span>Error & Widget Error</span>
                    <span>
                        This is a generic component presenting error Experiences. A more specialized version is used by the Dashboard WidgetHost.
                    </span>
                    <div className="demo-visual-cell one-by-one-layout">
                        <ErrorMessage
                            visualTitle={visualName}
                            messageBodyText="Rut roh!"
                            size={{ width: 160, height: 160 }}
                            action={{
                                text: "Something bad happened.",
                                ariaLabel: "AriaLabel",
                                onClick: this.onErrorClick
                            }}
                        />
                    </div>
                    <div className="demo-visual-cell two-by-two-layout">
                        <ErrorMessage
                            visualTitle={visualName}
                            messageBodyText="Rut roh!"
                            size={{ width: 330, height: 330 }}
                            action={{
                                text: "Something bad happened.",
                                ariaLabel: "AriaLabel",
                                onClick: this.onErrorClick
                            }}
                        />
                    </div>
                </div>
            </div>
        );
    }

    private onSetIterationClick = (): void => {
        alert("User has initiated click on SetIterationDatesMessage");
    };
    private onErrorClick = (): void => {
        alert("User has initiated click on Error Widget ");
    };
}
